import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { calcularDiferencia } from "../../helpers/transformers";
import AlmacenChip from "./AlmacenChip";
import DiferenciaBadge from "./DiferenciaBadge";

/**
 * Resultado de una línea nave a nave: almacén, stock teórico congelado, lo
 * contado y su diferencia (modo resultado, solo lectura)
 */
const ConteosPorNave = ({ conteos }) => {
    if (!conteos?.length) {
        return <Typography sx={{ fontSize: 12, color: "#6c757d" }}>Sin contar en ninguna nave</Typography>;
    }

    return (
        <Stack spacing={0.75}>
            {conteos.map((conteo) => {
                const { diferencia, contado } = calcularDiferencia(conteo.stockTeorico ?? 0, conteo.cantidadContada);
                return (
                    <Box key={conteo.almacen} sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                        <AlmacenChip codigo={conteo.almacen} estilos={{ height: 22, fontSize: 10 }} />
                        <Typography sx={{ fontSize: 12, color: "#495057", flex: 1 }}>
                            Teórico: <strong>{conteo.stockTeorico ?? "-"}</strong> · Contado: <strong>{conteo.cantidadContada}</strong>
                        </Typography>
                        <DiferenciaBadge diferencia={diferencia} contado={contado} />
                    </Box>
                );
            })}
        </Stack>
    );
};

export default ConteosPorNave;
